import { EventEmitter, Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoRecepcionadoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerDocRecepcionadoExcel(inputParams: {
    entidad: {
      rut_receptor: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      tipo_dte_codigo: number
      retornaExcel: boolean
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: documento_recepcionadoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recepcionado {
            obtenerDocRecepcionado(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.obtenerDocRecepcionado
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerDocRecepcionado(inputParams: {
    entidad: {
      rut_receptor: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      tipo_dte_codigo: number
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: documento_recepcionadoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recepcionado {
            obtenerDocRecepcionado(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_receptor
                  rut_emisor
                  cliente_proveedor_nombre
                  folio
                  tipo_dte_codigo
                  rut_usuario_recepcion
                  fecha_recepcion
                  fecha_registro
                  fecha_vencimiento
                  dia_recepcion
                  mes_recepcion
                  monto_total
                  monto_afecto
                  monto_exento
                  monto_descuento
                  monto_recargo
                  monto_subtotal
                  monto_imp_adic
                  monto_iva
                  estado_doc_recepcionado
                  tipo_devolucion
                  motivo_devolucion_codigo
                  motivo_devolucion_nombre
                  folio_referencia
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.obtenerDocRecepcionado
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerTotalLinea(inputParams
    , callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documento_recepcionado_detalleInputType) {
            documento_recepcionado_detalle {
              obtenerTotalLinea(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  folio
                  nro_linea
                  producto_proveedor
                  producto_proveedor_descripcion
                  formato_codigo
                  factor_equivalencia
                  producto_codigo
                  sku
                  producto_descripcion
                  formato_codigo_top
                  formato_nombre_top
                  cantidad_recibida
                  desc_es_porcentaje
                  descuento
                  rec_es_porcentaje
                  recargo
                  es_activo_fijo
                  tipo_item_codigo
                  impuesto_codigo
                  total_linea
                }
              }
            }
          }
          `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado_detalle.obtenerTotalLinea
        callback({ mensajes, respuesta })
      }
    );
  }

  existeFolio(inputParams
    , callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documento_recepcionadoInputType) {
            documento_recepcionado {
              existeFolio(entidad: $entidad) {
                mensajes{
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta
              }
            }
          }
          `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.existeFolio
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarFacturaRecepcionado(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: documento_recepcionadoInputType) {
          documento_recepcionado {
            guardarFacturaRecepcionado(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rut_receptor
                rut_emisor
                folio
                tipo_dte_codigo
                rut_usuario_recepcion
                dia_recepcion
                mes_recepcion
              }
            }
          }
        }
          `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.guardarFacturaRecepcionado
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarNotaCreditoRecepcionado(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documento_recepcionadoInputType, $entidadReferencia: documento_recepcionadoInputType) {
            documento_recepcionado {
              guardarNotaCreditoRecepcionado(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  rut_receptor
                  sucursal_codigo
                  rut_emisor
                  tipo_dte_codigo
                  folio
                }
              }
            }
          }
          `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.guardarNotaCreditoRecepcionado
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerMontoImpuesto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: documento_recepcionadoInputType) {
          documento_recepcionado {
            montoIVA(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recepcionado.montoIVA
        callback({ mensajes, respuesta })
      }
    );
  }
}
